import { memo } from 'react';
import classNames from 'classnames';
import { priceFormatSuperscript } from '@/lib/price';
import { priceFormater } from '@/settings/index';
import i18n from '@/settings/i18n';

const t = i18n.init('cart');

const SavingsBadge = memo(
  ({
    savings,
    comparePrice,
    className,
    comparePriceClassName,
  }: {
    savings: number | null;
    comparePrice: number | null;
    className?: string;
    comparePriceClassName?: string;
  }) => {
    if (comparePrice == null) {
      return null;
    }

    return (
      <div
        className={classNames(
          'flex shrink-0 items-center justify-end gap-2',
          className,
        )}
      >
        {savings ? (
          <div className="shrink-0 rounded bg-[#D5FFE2] px-2 py-1 text-[11px] font-medium leading-tight text-[#128452]">
            {t`Save`}{' '}
            <span translate="no">
              {priceFormatSuperscript(priceFormater.long(savings))}
            </span>
          </div>
        ) : null}
        <span
          className={classNames(
            'text-xs text-[#99A1AF] line-through xxs:text-sm',
            comparePriceClassName,
          )}
          translate="no"
        >
          {priceFormatSuperscript(priceFormater.long(comparePrice))}
        </span>
      </div>
    );
  },
);

SavingsBadge.displayName = 'SavingsBadge';

export default SavingsBadge;
